import { render, staticRenderFns } from "./DashboardBusinessDetails.vue?vue&type=template&id=de4d285c&"
import script from "./DashboardBusinessDetails.vue?vue&type=script&lang=ts&"
export * from "./DashboardBusinessDetails.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardBusinessDetails.vue?vue&type=style&index=0&id=de4d285c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports